<template>
  <a :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-success text-decoration-none" v-if="participation.invitation?.completionDate"><i class="fa-solid fa-check"></i> Inscrit le {{ formatDate(participation.invitation.completionDate,'DD/MM/YYYY à HH[h]mm') }}</a>
  <a :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-warning text-decoration-none" v-else-if="participation.invitation?.refusalDate"><i class="fa-solid fa-xmark"></i> Ne participe pas</a>
  <template v-else-if="participation.invitation?.lastUpdateDate">
    <a v-if="participation.invitation.reminderSentDate && participation.invitation.reminderSentDate > participation.invitation.lastUpdateDate" :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-info text-decoration-none"><i class="fa-solid fa-bell"></i> Relance envoyée le {{ formatDate(participation.invitation.reminderSentDate,'DD/MM/YYYY') }}</a>
    <a v-else :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-info text-decoration-none"><i class="fa-regular fa-hourglass-half"></i> Non finalisé</a>
  </template>
  <template v-else-if="participation.invitation?.sentDate">
    <a v-if="participation.invitation.reminderSentDate" :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-info text-decoration-none"><i class="fa-solid fa-bell"></i> Relance envoyée le {{ formatDate(participation.invitation.reminderSentDate,'DD/MM/YYYY') }}</a>
    <a v-else :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-info text-decoration-none"><i class="fa-regular fa-envelope"></i> Invitation envoyée le {{ formatDate(participation.invitation.sentDate,'DD/MM/YYYY') }}</a>
  </template>
  <a :href="getEditParticipationUrl(participation.user!.id)" target="_blank" rel="noopener noreferrer" class="text-primary text-decoration-none" v-else><i class="fa-solid fa-xmark"></i> Non Envoyé</a>
</template>
<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { formatDate } from '@/compositions/helper';

  const router = useRouter();

  const props = defineProps<{
    participation: ParticipationDb,
  }>();

  const getEditParticipationUrl = (userId: number) => {
    return router.resolve({
      name: 'travel',
      params: { id: props.participation.travelDbId },
      query: { impersonatedUserId: userId },
    }).href;
  };
</script>
